import React from 'react';
import { CloudSnow, Route, Smartphone, Receipt, Users, BarChart3, Wrench, FileText } from 'lucide-react';
interface ModuleGridProps {
  onModuleClick: (moduleId: string) => void;
}
const modules = [{
  id: 'weather',
  icon: CloudSnow,
  title: 'Météo & Déclenchement',
  description: 'Micro-prévisions et déclenchement automatique',
  status: 'active',
  color: 'blue'
}, {
  id: 'planning',
  icon: Route,
  title: 'Planification & Optimisation',
  description: 'Génération de rangs et scénarios P10/P50/P90',
  status: 'active',
  color: 'purple'
}, {
  id: 'operations',
  icon: Smartphone,
  title: 'Opérations Terrain',
  description: 'App mobile, punch, GPS et rapports',
  status: 'active',
  color: 'green'
}, {
  id: 'billing',
  icon: Receipt,
  title: 'Facturation',
  description: 'Génération automatique et sync QuickBooks',
  status: 'active',
  color: 'orange'
}, {
  id: 'franchise',
  icon: Users,
  title: 'Portail Franchisés',
  description: 'Performances, revenus et documents',
  status: 'active',
  color: 'indigo'
}, {
  id: 'dashboard',
  icon: BarChart3,
  title: 'Tableau de Bord',
  description: 'Vue temps réel et KPIs consolidés',
  status: 'active',
  color: 'cyan'
}, {
  id: 'multiservice',
  icon: Wrench,
  title: 'Multi-Service',
  description: 'Déneigement, portes automatiques et plus',
  status: 'beta',
  color: 'yellow'
}, {
  id: 'audit',
  icon: FileText,
  title: 'Audit & Exports',
  description: "Journal d'audit et exports CSV/PDF",
  status: 'active',
  color: 'gray'
}];
const colorClasses = {
  blue: 'bg-blue-100 text-blue-600 group-hover:bg-blue-200',
  purple: 'bg-purple-100 text-purple-600 group-hover:bg-purple-200',
  green: 'bg-green-100 text-green-600 group-hover:bg-green-200',
  orange: 'bg-orange-100 text-orange-600 group-hover:bg-orange-200',
  indigo: 'bg-indigo-100 text-indigo-600 group-hover:bg-indigo-200',
  cyan: 'bg-cyan-100 text-cyan-600 group-hover:bg-cyan-200',
  yellow: 'bg-yellow-100 text-yellow-600 group-hover:bg-yellow-200',
  gray: 'bg-gray-100 text-gray-600 group-hover:bg-gray-200'
};
export function ModuleGrid({
  onModuleClick
}: ModuleGridProps) {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-282">
      <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-283">Modules</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-284">
        {modules.map(module => {
        const Icon = module.icon;
        return <button key={module.id} onClick={() => onModuleClick(module.id)} className="group flex items-start space-x-4 p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all text-left" data-id="element-285">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${colorClasses[module.color as keyof typeof colorClasses]}`} data-id="element-286">
                <Icon className="w-6 h-6" data-id="element-287" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-288">
                <div className="flex items-center space-x-2" data-id="element-289">
                  <h3 className="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-290">
                    {module.title}
                  </h3>
                  {module.status === 'beta' && <span className="px-2 py-0.5 bg-yellow-100 text-yellow-700 text-xs font-medium rounded" data-id="element-291">
                      Beta
                    </span>}
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-292">
                  {module.description}
                </p>
              </div>
            </button>;
      })}
      </div>
    </div>;
}